// R1b-δ Fix #1 — Admin-or-Owner route gate.
// OWNER_SUPER_ADMIN and ADMINISTRATOR render; everyone else is redirected once to their role home (no loop —
// see RoleDenied) before AdminAppShell mounts. No chrome leak.
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import RoleDenied from "./RoleDenied";

const ALLOWED = new Set(["OWNER_SUPER_ADMIN", "ADMINISTRATOR"]);

export default function AdminOrOwnerRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-erf-cream">
        <div className="font-mono text-xs text-erf-dark/60">Authenticating…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user && user.must_rotate_password) return <Navigate to="/auth/rotate" replace />;
  if (!ALLOWED.has(user.role_key)) return <RoleDenied user={user} />;
  return children;
}
